import React, { useRef, useEffect } from "react";
import { loop } from "utils/array";
import { getRetinaContext } from "retina-canvas/retina-canvas";

import styles from "./CritterTile.module.css";

const roundedRect = (ctx, x, y, width, height, radius) => {
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.lineTo(x + width - radius, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
  ctx.lineTo(x + width, y + height - radius);
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
  ctx.lineTo(x + radius, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
  ctx.lineTo(x, y + radius);
  ctx.quadraticCurveTo(x, y, x + radius, y);
  ctx.closePath();
};

const green = "#c6b726";
const red = "#e75637";
const grey = "rgba(71, 66, 13, 0.4)";

const TimeAndSeasonGraph = ({ critter, hemisphere, now }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (canvasRef.current) {
      const ctx = getRetinaContext(canvasRef.current);
      const width = 135;
      const height = Math.min(114, (window.innerHeight - 175) / 5);
      ctx.clearAll();
      ctx.setWidth(width);
      ctx.setHeight(height);

      ctx.setFillStyle(grey);
      ctx.fillRect(3, height - 11, 129, 1);
      ctx.fillRect(3, height - 22, 129, 1);
      ctx.fillRect(3, height - 27, 129, 1);
      ctx.fillRect(3, height - 21, 1, 10);
      ctx.fillRect(3, height - 37, 1, 10);
      let offset = 5;
      let selectedWidth = 0;
      let selectedOffset = 0;

      const currentMonth = now.getMonth();

      loop(12, (_, i) => {
        // 010010010010
        if ((i + 2) % 3 === 0) {
          ctx.setFillStyle(green);
          if (i === currentMonth) {
            ctx.setFillStyle(red);
            selectedWidth = 10;
            selectedOffset = offset - 1.5;
          }
          if (critter.season[hemisphere][i]) {
            roundedRect(ctx, offset, height - 20, 7, 8, 2);
            ctx.fill();
          }
          offset += 10;
          ctx.setFillStyle(grey);
          ctx.fillRect(offset - 2, height - 21, 1, 10);
          ctx.fillRect(offset - 2, height - 37, 1, 10);
        } else {
          ctx.setFillStyle(green);
          if (i === currentMonth) {
            ctx.setFillStyle(red);
            selectedWidth = 11;
            selectedOffset = offset - 1.5;
          }
          if (critter.season[hemisphere][i]) {
            roundedRect(ctx, offset, height - 20, 8, 8, 2);
            ctx.fill();
          }
          offset += 11;
          ctx.setFillStyle(grey);
          ctx.fillRect(offset - 2, height - 21, 1, 10);
          ctx.fillRect(offset - 2, height - 37, 1, 10);
        }
      });

      ctx.setStrokeStyle(red);
      ctx.setLineWidth(1);
      ctx.strokeRect(selectedOffset, height - 21.5, selectedWidth, 11);

      ctx.setFillStyle(red);
      ctx.fillRect(
        5 + (now.getHours() * 60 + now.getMinutes()) / 11.6,
        height - 39,
        2,
        15
      );
    }
  }, [critter.season, hemisphere, now]);

  return <canvas className={styles.canvas} ref={canvasRef} />;
};

export default TimeAndSeasonGraph;
